import React, { Component } from "react";
import { observer } from "mobx-react";
import { Accessor, AlertX, ColorX, GFunc, GState, LocaleX, NavX, ResponsiveX, ZArray } from "IZOX/STATIC";
// eslint-disable-next-line no-unused-vars
import PropsType from "prop-types";
import { HStack, VStack, XButton, XScroll, XText } from "IZOX/_X";
import StepDot from "shared/StepDot";
import { QForm } from "IZOX/BLOCKS/Libs";
import { QFCheckBox, QFDropUpload } from "IZOX/BLOCKS/Libs/QForm/_gears";
import APIExpress from "__SYSDefault/APIs/APIExpress";
import Styles from "__SYSDefault/Styles";
import ZValidate from "IZOX/STATIC/ZValidate";
import { withRouter } from "react-router-dom/cjs/react-router-dom";
import _ from "lodash";
import Options from "shared/Options";
import { MdClose } from "react-icons/md";
import VarList from "shared/VarList";
import QUICKUI from "shared/QUICKUI";
import NewPolicy from "../PDCAllPolicies/_gears/NewPolicy";
import { SysConfig } from "__SYSDefault/Config";

/**
 * @augments {Component<Props, State>}
 */
class PDCProfile extends Component {

  static propTypes = {

  }

  static defaultProps = {

  }

  constructor(){
    super();
    this.state = {
      step: 0
    };
  }

  componentDidMount(){
    this._setAllStates(() => {
      this._GetSelfProfile();
      this.GetBankList();
    });
  }

  componentDidUpdate(prevProps, prevState){
    if(!Accessor.IsIdentical(prevProps, this.props, Object.keys(PDCProfile.defaultProps))){
      this._setAllStates();
    }
  }

  componentWillUnmount() {
    this.setState = (state, callback) => {
      return;
    };
  }

  _setAllStates = (callback) => {
    this.setState((state, props) => ({
      ...props,
    }), callback);
  }

  _GetSelfProfile = async () => {
    let res = await APIExpress.User.GetSelfProfile();
    let {Success, payload} = res;
    if(Success){
      payload = {...payload, zip: "+852"};
      this.setState({
        Q1Form: payload
      });
    }
  }

  GetBankList = async () => {
    let docs = await VarList.GetList("Bank");
    this.setState({
      banks: docs
    });
  }

  _toNewPolicy = () => {
    GFunc.Backdrop(() => {
      return <NewPolicy/>;
    }, {}, false);
  }

  _toStep = (step) => {
    GState.UPDATE("profileStep", step);
  }

  _toRedirect = () => {
    let {history} = this.props;
    NavX.Goto(history, "/Home");
  }

  _step1Back = () => {
    this._toRedirect();
  }

  _addRow = (name) => {
    let {Q1Form} = this.state;
    let target = Accessor.Get(Q1Form, name) ?? [];
    target = [...target, ""];
    Accessor.Set(Q1Form, name, target);
    this.setState({
      Q1Form: Q1Form
    });
  }

  _removeRow = (name, idx) => {
    let {Q1Form} = this.state;
    let target = Accessor.Get(Q1Form, name);
    target = ZArray.DeleteIdx(target, idx);
    Accessor.Set(Q1Form, name, target);
    this.setState({
      Q1Form: Q1Form
    });
  }

  _step1Next = async () => {
    let {Q1Form} = this.state;
    if(!ZValidate.CheckAllFields(Q1Form, 
        [
          "meta.fullName.EN", "email", "telNo",
          "meta.gender", "meta.HKID", "meta.dateOfBirth",
          "meta.primaryAddress.EN"
        ], ["required"])){
          AlertX.RequiredFields();
          return;
        }
    if(!ZValidate.CheckAllFields(Q1Form, ["meta.HKID"], ["isHKID"])){
      GFunc.Alert({
        EN: "HKID number is invalid.",
        TC: "香港身份證號碼無效"
      }, "error");
      return;
    }
    if(!Accessor.Get(Q1Form, "sameAsPrimary") 
      && !ZValidate.CheckAllFields(Q1Form, "meta.mailingAddress.EN", "required")){
        AlertX.RequiredFields();
        return;
    }
    GState.UPDATE("profileFormData", Q1Form);
    this._toStep(2);
  }

  _step2Next = async () => {
    let {Q2Form} = this.state;
    let formData = GState.GET("profileFormData");
    let HKIDAtth = Accessor.Get(Q2Form, "meta.HKIDAtth");
    let allUploaded = _.every(HKIDAtth, o => o.active);
    if(_.isEmpty(HKIDAtth)){
      GFunc.Alert({
        EN: "Please upload at least one file for HKID Verification.",
        TC: "請上傳至少一個文件以進行 HKID 驗證"
      }, "warn");
      return;
    }
    if(!allUploaded){
      GFunc.Alert({
        EN: "Please wait until all the files are uploaded.",
        TC: "請等待所有文件上傳完畢。"
      }, "warn");
      return;
    }
    let formCombined = Accessor.DeepReplace(formData, Q2Form);
    GState.UPDATE("profileFormData", formCombined);
    this._toStep(2);
  }

  _step3Next = async () => {
    let {Q3Form} = this.state;
    let formData = GState.GET("profileFormData");
    let BankAtth = Accessor.Get(Q3Form, "meta.BankAtth");
    let allUploaded = _.every(BankAtth, o => o.active);
    if(_.isEmpty(BankAtth)){
      GFunc.Alert({
        EN: "Please upload at least one file for Bank Account Verification.",
        TC: "請上傳至少一個文件以進行 銀行戶口 驗證"
      }, "warn");
      return;
    }
    if(!allUploaded){
      GFunc.Alert({
        EN: "Please wait until all the files are uploaded.",
        TC: "請等待所有文件上傳完畢。"
      }, "warn");
      return;
    }
    let formCombined = Accessor.DeepReplace(formData, Q3Form);
    
    GState.UPDATE("profileFormData", formCombined);

    let res = await APIExpress.User.SubmitProfile(formCombined);
    let {Success, payload} = res;
    if(Success){
      await APIExpress.User.Refresh();
      this._toStep(3);
    }else{
      GFunc.Alert(payload, "error");
    }
  }

  _step2Back = () => {
    this._toStep(0);
  }

  _step3Back = () => {
    this._toStep(0);
  }

  Q1Change = (formValue) => {
    this.setState({
      Q1Form: formValue
    });
  }

  Q2Change = (formValue) => {
    this.setState({
      Q2Form: formValue
    });
  }

  Q3Change = (formValue) => {
    this.setState({
      Q3Form: formValue
    });
  }

  validQ1 = () => {
    let {Q1Form} = this.state;
    let valid = true;
    valid = ZValidate.CheckAllFields(Q1Form, 
      [
        "meta.fullName.EN", 
        "email", 
        "telNo",
        "meta.gender", 
        "meta.HKID", 
        "meta.dateOfBirth",
        "meta.primaryAddress", 
        "meta.bankID",
        "meta.bankPayee",
        "meta.bankACNo"
      ], "required");
    if(!valid) return false;

    if(!Accessor.Get(Q1Form, "sameAsPrimary") 
      && !ZValidate.CheckAllFields(Q1Form, "meta.mailingAddress", "required")){
        return false;
    }

    return true;
  }

  validQ2 = () => {
    let {Q2Form} = this.state;
    let valid = true;
    valid = ZValidate.CheckAllFields(Q2Form, 
      [
        "meta.HKIDAtth"
      ], "required");
    if(!valid) return false;
    valid = ZValidate.CheckUploads(Q2Form, 
      [
        "meta.HKIDAtth"
      ]);
    return valid;
  }

  validQ3 = () => {
    let {Q3Form} = this.state;
    let valid = true;
    valid = ZValidate.CheckAllFields(Q3Form, 
      [
        "meta.BankAtth"
      ], "required");
    if(!valid) return false;
    valid = ZValidate.CheckUploads(Q3Form, 
      [
        "meta.BankAtth"
      ]);
    return valid;
  }

  renderStep1QFormM(){
    let {Q1Form} = this.state;
    return (
      <XScroll fullWidth>
        <QForm pT={29} fullWidth pH={24} pB={50} 
          value={Q1Form} 
          onChange={this.Q1Change}>
          {this.renderTitle(
            {
              EN: "Profile",
              TC: "個人資料"
            },
            // {
            //   EN: "Lorem ipsum dolor sit amet consectetur malesuada.",
            //   TC: "Lorem ipsum dolor sit amet consectetur malesuada."
            // }
          )}
          {this.renderSection1M()}
          {this.renderSection2M()}
          {this.renderButton(this._step1Back, this._step1Next, undefined, undefined, this.validQ1)}
        </QForm>
      </XScroll>
    );
  }

  renderStep1QFormPC(){
    let {Q1Form} = this.state;
    return (
      <XScroll fullWidth>
        <QForm pT={29} fullWidth pH={24} pB={50} 
          value={Q1Form} 
          onChange={this.Q1Change}>
          {this.renderTitle(
            {
              EN: "Profile",
              TC: "個人資料"
            },
            // {
            //   EN: "Lorem ipsum dolor sit amet consectetur malesuada.",
            //   TC: "Lorem ipsum dolor sit amet consectetur malesuada."
            // }
          )}
          {this.renderSection1()}
          {this.renderSection2()}
          {this.renderButton(this._step1Back, this._step1Next, undefined, undefined, this.validQ1)}
        </QForm>
      </XScroll>
    );
  }

  renderStep1QForm(){
    return ResponsiveX.Split({
      0: () => this.renderStep1QFormM(),
      [SysConfig.WebUIWidth]: () => this.renderStep1QFormPC(),
    });
  }

  renderTitle(title, subtitle){
    return (
      <VStack pV={24} fullWidth>
        <XText color={ColorX.CSS("Leaf")} fontSize={32} bold>
          {LocaleX.Parse(title)}
        </XText>
        <XText color={ColorX.CSS("Leaf")} fontSize={14} newLine textAlign="|">
          {LocaleX.Parse(subtitle)}
        </XText>
      </VStack>
    );
  }

  renderSectionTitleLine(caption){
    return (
      <VStack fullWidth pB={48}>
        <HStack bgColor={ColorX.CSS("Axit")} pH={48} pV={12} HAlign="[">
          <XText color={ColorX.CSS("pureWhite")} fontSize={16} bold>
            {LocaleX.Parse(caption)}
          </XText>
        </HStack>
      </VStack>
    );
  }

  renderSection1M(){
    let {Q1Form} = this.state;
    let additionalAddress = Accessor.Get(Q1Form, "meta.additionalAddress");
    let sameAsPrimary = Accessor.Get(Q1Form, "sameAsPrimary");
    return (
      <VStack fullWidth pB={48} HAlign="[" spacing={16}>
        {QUICKUI.AFSectionLine({
          EN: "Personal information",
          TC: "個人資料"
        })}
        {QUICKUI.WebTextField("meta.fullName.EN",
          {EN: "Full name", TC: "姓名"},
          {width: "100%", errorMessage: 
            ZValidate.GetErrorMsg(Accessor.Get(Q1Form, "meta.fullName.EN"), 
            ["required"])}
        )}
        {QUICKUI.WebTextField("meta.fullName.TC",
          {EN: "Full name (Chinese name)", TC: "姓名(中文)"},
          {width: "100%", starred: false}
        )}
        {QUICKUI.WebTextField("meta.HKID",
          {EN: "HKID A123456(7)", TC: "香港身份證 A123456(7)"},
          {width: "100%", errorMessage: 
            ZValidate.GetErrorMsg(Accessor.Get(Q1Form, "meta.HKID"), 
            ["required", "isHKID"])}
        )}
        {QUICKUI.WebDateField("meta.dateOfBirth",
          {EN: "Date of birth", TC: "出生日期"},
          {width: "100%", errorMessage: 
            ZValidate.GetErrorMsg(Accessor.Get(Q1Form, "meta.dateOfBirth"), 
            ["required"])},
        )}
        {QUICKUI.WebDropdown("meta.gender",
          {EN: "Gender", TC: "性別"},
          Options.GetOptionList("Gender"),
          {width: "100%", placeholder: {EN: "Gender", TC: "性別"}, 
          errorMessage: 
            ZValidate.GetErrorMsg(Accessor.Get(Q1Form, "meta.gender"), 
            ["required"])},
        )}
        {QUICKUI.WithZipCode("telNo",
            {EN: "Mobile phone", TC: "手機號碼"},
            {width: "100%", errorMessage: 
              ZValidate.GetErrorMsg(Accessor.Get(Q1Form, "telNo"), 
              ["required"])},
          )}
        {QUICKUI.WebTextField("email",
          {EN: "Email", TC: "電郵"},
          {width: "100%", readOnly: true}
        )}
        {QUICKUI.WebTextField("meta.primaryAddress.EN",
          {EN: "Primary address (English)", TC: "主要地址 (英文)"},
          {width: "100%", errorMessage: 
            ZValidate.GetErrorMsg(Accessor.Get(Q1Form, "meta.primaryAddress.EN"), 
            ["required"])},
        )}
        {QUICKUI.WebTextField("meta.primaryAddress.TC",
          {EN: "Primary address (Chinese)", TC: "主要地址 (中文)"},
          {width: "100%", starred: false},
        )}
        {QUICKUI.WebTextField("meta.mailingAddress.EN",
          { EN: "Mailing address (English)", TC: "郵寄地址 (英文)" },
          {width: "100%", readOnly: sameAsPrimary, errorMessage: 
            sameAsPrimary ? "" : ZValidate.GetErrorMsg(Accessor.Get(Q1Form, "meta.mailingAddress.EN"), 
            ["required"])}
        )}
        {QUICKUI.WebTextField("meta.mailingAddress.TC",
          { EN: "Mailing address (Chinese)", TC: "郵寄地址 (中文)" },
          {width: "100%", readOnly: sameAsPrimary, starred: false},
          <HStack width={"auto"} spacing={5}>
            <QFCheckBox
              bColor={ColorX.CSS("Stone")} 
              bgColor={ColorX.CSS("pureWhite")}
              color={ColorX.CSS("pureWhite")}
              name="sameAsPrimary"
              size={14}
              />
            <XText fontSize={12} color={ColorX.CSS("Stone")}>
              {LocaleX.Parse({
                EN: "Same as primary address",
                TC: "與主要地址相同"
              })}
            </XText>
          </HStack>
        )}
        <VStack HAlign="[" fullWidth spacing={24}>
          {_.map(additionalAddress, (o, i) => {
            return (
              <VStack fullWidth VAlign="_" key={i} HAlign="[" spacing={24}>
                {QUICKUI.WebTextField(`meta.additionalAddress.${i}.EN`, 
                  {
                    EN: `Additional Address #${i+1} (English)`,
                    TC: `附加地址 #${i+1} (英文)`
                  }, {width: "100%", starred: false, errorMessage: 
                    ZValidate.GetErrorMsg(Accessor.Get(Q1Form, `meta.additionalAddress.${i}.EN`), 
                    ["required"])})}
                <HStack VAlign="_">
                  {QUICKUI.WebTextField(`meta.additionalAddress.${i}.TC`, 
                    {
                      EN: `Additional Address #${i+1} (Chinese)`,
                      TC: `附加地址 #${i+1} (中文)`
                    }, {width: "90%", starred: false})}
                  <XButton color={ColorX.CSS("Blood")} fullHeight width={40}
                    onPress={() => this._removeRow("meta.additionalAddress", i)}>
                    <MdClose/>
                  </XButton>
                </HStack>
              </VStack>
            );
          })}
          <XButton color={ColorX.CSS("Axit")} onPress={() => this._addRow("meta.additionalAddress")}>
            <HStack>
              <XText bold>
                {LocaleX.Parse({
                  EN: "+ Add more address",
                  TC: "+ 增加更多地址"
                })}
              </XText>
            </HStack>
          </XButton>
        </VStack>
      </VStack>
    );
  }

  renderSection1(){
    let {Q1Form} = this.state;
    let additionalAddress = Accessor.Get(Q1Form, "meta.additionalAddress");
    let sameAsPrimary = Accessor.Get(Q1Form, "sameAsPrimary");
    return (
      <VStack fullWidth pB={48} HAlign="[" spacing={16}>
        {QUICKUI.AFSectionLine({
          EN: "Personal information",
          TC: "個人資料"
        })}
        <HStack spacing={24}>
          {QUICKUI.WebTextField("meta.fullName.EN",
            {EN: "Full name", TC: "姓名"},
            {width: "50%", errorMessage: 
              ZValidate.GetErrorMsg(Accessor.Get(Q1Form, "meta.fullName.EN"), 
              ["required"])}
          )}
          {QUICKUI.WebTextField("meta.fullName.TC",
            {EN: "Full name (Chinese name)", TC: "姓名(中文)"},
            {width: "50%", starred: false}
          )}
        </HStack>
        <HStack spacing={24}>
          {QUICKUI.WebTextField("meta.HKID",
            {EN: "HKID A123456(7)", TC: "香港身份證 A123456(7)"},
            {width: "50%", errorMessage: 
              ZValidate.GetErrorMsg(Accessor.Get(Q1Form, "meta.HKID"), 
              ["required", "isHKID"])}
          )}
          <HStack width={"50%"} spacing={24}>
            {QUICKUI.WebDateField("meta.dateOfBirth",
              {EN: "Date of birth", TC: "出生日期"},
              {width: "50%", errorMessage: 
                ZValidate.GetErrorMsg(Accessor.Get(Q1Form, "meta.dateOfBirth"), 
                ["required"])},
            )}
            {QUICKUI.WebDropdown("meta.gender",
              {EN: "Gender", TC: "性別"},
              Options.GetOptionList("Gender"),
              {width: "50%", placeholder: {EN: "Gender", TC: "性別"}, 
              errorMessage: 
                ZValidate.GetErrorMsg(Accessor.Get(Q1Form, "meta.gender"), 
                ["required"])},
            )}
          </HStack>
        </HStack>
        <HStack spacing={24}>
          {QUICKUI.WithZipCode("telNo",
              {EN: "Mobile phone", TC: "手機號碼"},
              {width: "50%", errorMessage: 
                ZValidate.GetErrorMsg(Accessor.Get(Q1Form, "telNo"), 
                ["required"])},
            )}
          {QUICKUI.WebTextField("email",
            {EN: "Email", TC: "電郵"},
            {width: "50%", readOnly: true}
          )}
        </HStack>
        <HStack HAlign="[" spacing={24}>
          {QUICKUI.WebTextField("meta.primaryAddress.EN",
            {EN: "Primary address (English)", TC: "主要地址 (英文)"},
            {width: "50%", errorMessage: 
              ZValidate.GetErrorMsg(Accessor.Get(Q1Form, "meta.primaryAddress.EN"), 
              ["required"])},
          )}
          {QUICKUI.WebTextField("meta.primaryAddress.TC",
            {EN: "Primary address (Chinese)", TC: "主要地址 (中文)"},
            {width: "50%", starred: false},
          )}
        </HStack>
        <HStack HAlign="[" spacing={24}>
          {QUICKUI.WebTextField("meta.mailingAddress.EN",
            { EN: "Mailing address (English)", TC: "郵寄地址 (英文)" },
            {width: "50%", readOnly: sameAsPrimary, errorMessage: 
              sameAsPrimary ? "" : ZValidate.GetErrorMsg(Accessor.Get(Q1Form, "meta.mailingAddress.EN"), 
              ["required"])}
          )}
          {QUICKUI.WebTextField("meta.mailingAddress.TC",
            { EN: "Mailing address (Chinese)", TC: "郵寄地址 (中文)" },
            {width: "50%", readOnly: sameAsPrimary, starred: false},
            <HStack width={"auto"} spacing={5}>
                <QFCheckBox
                  bColor={ColorX.CSS("Stone")} 
                  bgColor={ColorX.CSS("pureWhite")}
                  color={ColorX.CSS("pureWhite")}
                  name="sameAsPrimary"
                  size={14}
                  />
                <XText fontSize={12} color={ColorX.CSS("Stone")}>
                  {LocaleX.Parse({
                    EN: "Same as primary address",
                    TC: "與主要地址相同"
                  })}
                </XText>
              </HStack>
          )}
        </HStack>
        <VStack HAlign="[" fullWidth spacing={24}>
          {_.map(additionalAddress, (o, i) => {
            return (
              <HStack VAlign="_" key={i} HAlign="[" spacing={24}>
                {QUICKUI.WebTextField(`meta.additionalAddress.${i}.EN`, 
                  {
                    EN: `Additional Address #${i+1} (English)`,
                    TC: `附加地址 #${i+1} (英文)`
                  }, {width: "50%", starred: false, errorMessage: 
                    ZValidate.GetErrorMsg(Accessor.Get(Q1Form, `meta.additionalAddress.${i}.EN`), 
                    ["required"])})}
                {QUICKUI.WebTextField(`meta.additionalAddress.${i}.TC`, 
                  {
                    EN: `Additional Address #${i+1} (Chinese)`,
                    TC: `附加地址 #${i+1} (中文)`
                  }, {width: "44%", starred: false})}
                <XButton color={ColorX.CSS("Blood")} 
                  onPress={() => this._removeRow("meta.additionalAddress", i)}>
                  <MdClose/>
                </XButton>
              </HStack>
            );
          })}
          <XButton color={ColorX.CSS("Axit")} onPress={() => this._addRow("meta.additionalAddress")}>
            <HStack>
              <XText bold>
                {LocaleX.Parse({
                  EN: "+ Add more address",
                  TC: "+ 增加更多地址"
                })}
              </XText>
            </HStack>
          </XButton>
        </VStack>
      </VStack>
    );
  }

  renderSection2M(){
    let {banks, Q1Form} = this.state;
    return (
      <VStack fullWidth pB={48}>
        {QUICKUI.AFSectionLine({
          EN: "Bank Information",
          TC: "銀行資訊"
        })}
        {QUICKUI.WebTextField("meta.bankPayee",
          {EN: "Payee", TC: "收款人"},
          {width: "100%", errorMessage: 
            ZValidate.GetErrorMsg(Accessor.Get(Q1Form, "meta.bankPayee"), 
            ["required"])}
        )}
        {QUICKUI.WebDropdown("meta.bankID", {
          EN: "Bank",
          TC: "銀行"
        }, banks, 
        {
          width: "100%", 
          valAccessor: "_id", 
          capAccessor: "name", 
          placeholder: {EN: "Select Bank...", TC: "選擇銀行..."}, 
          errorMessage: 
          ZValidate.GetErrorMsg(Accessor.Get(Q1Form, "meta.bankID"), 
          ["required"])
        })}
        {QUICKUI.WebPasswordField("meta.bankACNo",
          {EN: "Bank account number", TC: "銀行戶口號碼"},
          {width: "100%", errorMessage: 
            ZValidate.GetErrorMsg(Accessor.Get(Q1Form, "meta.bankACNo"), 
            ["required"]), autoComplete: "off"}
        )}
      </VStack>
    );
  }

  renderSection2(){
    let {banks, Q1Form} = this.state;
    return (
      <VStack fullWidth pB={48}>
        {QUICKUI.AFSectionLine({
          EN: "Bank Information",
          TC: "銀行資訊"
        })}
        <HStack spacing={24}>
          {QUICKUI.WebTextField("meta.bankPayee",
            {EN: "Payee", TC: "收款人"},
            {width: "50%", errorMessage: 
              ZValidate.GetErrorMsg(Accessor.Get(Q1Form, "meta.bankPayee"), 
              ["required"])}
          )}
          <HStack width={"50%"} spacing={16}>
            {QUICKUI.WebDropdown("meta.bankID", {
              EN: "Bank",
              TC: "銀行"
            }, banks, 
            {
              width: "50%", 
              valAccessor: "_id", 
              capAccessor: "name", 
              placeholder: {EN: "Select Bank...", TC: "選擇銀行..."}, 
              errorMessage: 
              ZValidate.GetErrorMsg(Accessor.Get(Q1Form, "meta.bankID"), 
              ["required"])
            })}
            {QUICKUI.WebPasswordField("meta.bankACNo",
              {EN: "Bank account number", TC: "銀行戶口號碼"},
              {width: "50%", errorMessage: 
                ZValidate.GetErrorMsg(Accessor.Get(Q1Form, "meta.bankACNo"), 
                ["required"]), autoComplete: "off"}
            )}
          </HStack>
        </HStack>
      </VStack>
    );
  }

  renderButton(backFunc, nextFunc, 
    backCap = { EN: "Back", TC: "返回" },
    nextCap = { EN: "Next", TC: "下一步"},
    validFunc = null
  ){
    return (
      <HStack spacing={16}>
        <XButton {...Styles.QFBtnInverse} width={200} onPress={backFunc}>
          <HStack>
            <XText bold>
              {LocaleX.Parse(backCap)}
            </XText>
          </HStack>
        </XButton>
        <XButton {...Styles.QFBtn} width={200} onPress={nextFunc}
          disabled={!validFunc?.()}>
          <HStack>
            <XText bold>
              {LocaleX.Parse(nextCap)}
            </XText>
          </HStack>
        </XButton>
      </HStack>
    );
  }

  renderStep2QForm(){
    let {Q2Form} = this.state;
    return (
      <XScroll>
        <QForm pT={10} fullWidth pH={24} pB={50} spacing={24}
          onChange={this.Q2Change} value={Q2Form}>
          {this.renderTitle(
            {
              EN: "Verify HKID",
              TC: "驗證你的香港身份證"
            },
            {
              EN: "In order to create an account, we need to be 100% sure that you are you.\nAs we're an insurance service, we have to comply with this.\nWhich will help us to build a secure system together",
              TC: "為了建立帳戶，我們需要 100% 確定您就是您本人。\n由於我們是保險服務機構，因此我們必須遵守這一點。\n這將有助於我們共同建構一個安全的系統"
            })}
          <VStack fullWidth spacing={10}>
            <HStack>
              <XText color={ColorX.CSS("Leaf")} bold>
                {LocaleX.Parse({
                  EN: "Upload your HKID here",
                  TC: "在此上傳您的香港身分證"
                })}
              </XText>
            </HStack>
            <HStack>
              <QFDropUpload 
                fileSizeLimit={10}
                name="meta.HKIDAtth"
                btnBgColor={ColorX.CSS("Axit")}
                color={ColorX.CSS("Stone")}
                previewColor={ColorX.CSS("Leaf")}
                accept=".jpg,.png,.pdf,.jpeg"
                instantUpload
                dropzone
                multiple
                uploadZoneProps={{
                  width: ResponsiveX.RefMin(300, 1070),
                }}
                previewZoneProps={{
                  width: ResponsiveX.RefMin(300, 1070),
                }}
                />
            </HStack>
          </VStack>
          {this.renderButton(this._step2Back, this._step2Next, undefined, 
            {
              EN: "Submit",
              TC: "提交"
            }, this.validQ2)}
        </QForm>
      </XScroll>
    );
  }

  renderStep3QForm(){
    let {Q3Form} = this.state;
    return (
      <XScroll>
        <QForm pT={10} fullWidth pH={24} pB={50} spacing={24}
          onChange={this.Q3Change} value={Q3Form}>
          {this.renderTitle(
            {
              EN: "Verify Bank Account",
              TC: "驗證你的銀行戶口"
            },
            {
              EN: "In order to create an account, we need to be 100% sure that you are you.\nAs we're an insurance service, we have to comply with this.\nWhich will help us to build a secure system together",
              TC: "為了建立帳戶，我們需要 100% 確定您就是您本人。\n由於我們是保險服務機構，因此我們必須遵守這一點。\n這將有助於我們共同建構一個安全的系統"
            })}
          <VStack fullWidth spacing={10}>
            <HStack>
              <XText color={ColorX.CSS("Leaf")} bold>
                {LocaleX.Parse({
                  EN: "Upload your Bank Account here",
                  TC: "在此上傳您的銀行戶口証明"
                })}
              </XText>
            </HStack>
            <HStack>
              <QFDropUpload 
                fileSizeLimit={10}
                name="meta.BankAtth"
                btnBgColor={ColorX.CSS("Axit")}
                color={ColorX.CSS("Stone")}
                previewColor={ColorX.CSS("Leaf")}
                accept=".jpg,.png,.pdf,.jpeg"
                instantUpload
                dropzone
                multiple
                uploadZoneProps={{
                  width: ResponsiveX.RefMin(300, 1070),
                }}
                previewZoneProps={{
                  width: ResponsiveX.RefMin(300, 1070),
                }}
                />
            </HStack>
          </VStack>
          {this.renderButton(this._step3Back, this._step3Next, undefined, 
            {
              EN: "Submit",
              TC: "提交"
            }, this.validQ3)}
        </QForm>
      </XScroll>
    );
  }

  renderThankYou(){
    return (
      <VStack fullHeight VAlign="-" spacing={24}>
        <XText fontSize={32} color={ColorX.CSS("Leaf")} bold>
          {LocaleX.Parse({
            EN: "Thank You",
            TC: "多謝"
          })}
        </XText>
        <XText fontSize={14} color={ColorX.CSS("Leaf")} textAlign="|">
          {LocaleX.Parse({
            EN: "Hi, I hope you're doing well.\nWe wanted to reach out to let you know that we've finished setting up your account.\nTo confirm that everything is accurate, please open the confirmation letter we sent via email.\nThank you for taking the time to confirm the details, it's greatly appreciated.",
            TC: "嗨，我希望你一切都好。\n我們希望與您聯繫，讓您知道我們已完成您的帳戶設定。\n為了確認一切準確無誤，請開啟我們透過電子郵件發送的確認信。\n感謝您花時間確認詳細信息，非常感謝。"
          })}
        </XText> 
        <XButton {...Styles.QFBtn} width={250} onPress={this._toNewPolicy}>
          <HStack>
            <XText bold>
              {LocaleX.Parse({
                EN: "Submit Policy Application",
                TC: "提交保單申請"
              })}
            </XText>
          </HStack>
        </XButton>
        <XButton {...Styles.QFBtnInverse} width={200} onPress={this._toRedirect}>
          <HStack>
            <XText bold>
              {LocaleX.Parse({
                EN: "Back to Home",
                TC: "返回首頁"
              })}
            </XText>
          </HStack>
        </XButton>
      </VStack>
    );
  }

  renderStep(){
    let step = GState.GET("profileStep");
    switch(step){
      default: case 0: return this.renderStep1QForm();
      case 1: return this.renderStep2QForm();
      case 2: return this.renderStep3QForm();
      case 3: return this.renderThankYou();
    }
  }

  render(){
    let step = GState.GET("profileStep");
    return (
      <VStack bgColor={ColorX.CSS("Grass")} fullHeight>
        <VStack maxWidth={"90%"} width={1070} bgColor={ColorX.CSS("pureWhite")} fullHeight>
          <HStack HAlign="[" height={24}>
            <StepDot curStep={step} maxStep={2} 
              inactiveColor={ColorX.CSS("NotQuiteWhite")}
              activeColor={ColorX.CSS("DeepBlueSea")} 
              style={{paddingTop: 12, marginLeft: 42}}/>
          </HStack>
          {this.renderStep()}
        </VStack>
      </VStack>
    );
  }

}

export default withRouter(observer(PDCProfile));
